import { useNavigate } from "react-router-dom";
import { useApiMutation } from "../../../../../common/infrastructure/hooks/useApiMutation";
import { useAppContext } from "../../../../../AppContext";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { endpointsMetadata } from "../../../../../common/infrastructure/routes/endpointsMetadata";
import { constructMyFamilyAddHref } from "../../../../../common/infrastructure/routes/routePaths";
import * as yup from "yup";
import { useFormValidationMessages } from "../../../../../common/infrastructure/hooks/useFormHelper";

const schema = yup.object({
  familyName: yup.string().required("Моля, въведете име на семейството").defined(),
});

export type ICreateFamilyFormModel = yup.InferType<typeof schema>;

export const useMyFamilyCreationDialog = (onClose: () => void) => {
  const navigate = useNavigate();
  const { mutateAsync } = useApiMutation();
  const { isDesktopOrTablet } = useAppContext();

  const width = isDesktopOrTablet ? "400px" : "90vw";

  const form = useForm<ICreateFamilyFormModel>({
    defaultValues: { familyName: "" },
    resolver: yupResolver(schema),
  });

  useFormValidationMessages<ICreateFamilyFormModel>(form);

  const onSubmit: SubmitHandler<ICreateFamilyFormModel> = async (data) => {
    try {
      const result = await mutateAsync({
        endpoint: endpointsMetadata.myFamily.initialFamilyCreation,
        method: "post",
        globalIsLoading: true,
        disableSuccessToast: true,
        ...data,
      });

      if (result) {
        navigate(constructMyFamilyAddHref(Number(result ?? 0)));
      }

      form.reset();
      onClose();
    } catch (e) {}
  };

  return { form, width, onSubmit };
};
